import * as t from "react";
import { KnockI18nProvider as v } from "../../i18n/context/KnockI18nProvider.mjs";
import K from "../hooks/useAuthenticatedKnockClient.mjs";
import "zustand/shallow";
const i = t.createContext(null), p = ({
  apiKey: e,
  host: o,
  logLevel: n,
  userId: u,
  userToken: s,
  onUserTokenExpiring: r,
  timeBeforeExpirationInMs: c,
  children: a,
  i18n: m
}) => {
  const k = t.useMemo(() => ({
    host: o,
    onUserTokenExpiring: r,
    timeBeforeExpirationInMs: c,
    logLevel: n
  }), [o, r, c, n]), d = K(e, u, s, k);
  return /* @__PURE__ */ t.createElement(i.Provider, { value: {
    knock: d
  } }, /* @__PURE__ */ t.createElement(v, { i18n: m }, a));
}, f = () => {
  const e = t.useContext(i);
  if (e === void 0)
    throw new Error("useKnock must be used within a KnockProvider");
  return e.knock;
};
export {
  p as KnockProvider,
  f as useKnockClient
};
//# sourceMappingURL=KnockProvider.mjs.map
